import { render, staticRenderFns } from "./SettingNotifications.vue?vue&type=template&id=601cff8e&"
import script from "./SettingNotifications.vue?vue&type=script&lang=js&"
export * from "./SettingNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports